module.exports = __webpack_public_path__ + "static/img/rank_8.09bc396.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_8.png
// module id = I5ii
// module chunks = 1